import { createContext, useContext } from 'react';

/**
 * Ce que le cadre du téléphone donne au haut de chaque écran (chantier telephone-habit, 02) :
 * l'initiale de la personne et le geste qui ouvre les Paramètres de l'app. Le cadre
 * (`telephone/CadreDuTelephone.tsx`) le pose ; hors de lui (l'ordinateur, un test), il n'y en a
 * pas, et le haut se passe de l'initiale.
 */
export interface CadreDuHaut {
  /** `null` : ni prénom ni e-mail, le rond ne se montre pas. */
  initiale: string | null;
  ouvrirLesParametres: () => void;
  /**
   * Le + de la barre du bas, ouvert déjà dans une bulle (chantier telephone-projet, 02 : les
   * « + une bulle dans « X » » de l'arbre d'un projet).
   */
  ouvrirLePlusDans?: (bulleId: string) => void;
}

export const ContexteDuHaut = createContext<CadreDuHaut | null>(null);

export function useCadreDuHaut(): CadreDuHaut | null {
  return useContext(ContexteDuHaut);
}

/**
 * L'initiale du rond en haut à gauche : la première lettre du prénom du Profil, sinon celle de
 * l'e-mail, en capitale ; sans l'un ni l'autre, `null` (le rond ne se montre pas).
 */
export function initialeDe(prenom: string | null | undefined, email: string | null | undefined): string | null {
  const source = prenom?.trim() || email?.trim() || '';
  const premiere = Array.from(source)[0];
  return premiere ? premiere.toLocaleUpperCase('fr-FR') : null;
}
